(function() {
    $(document).ready(function() {
        const containers = document.querySelectorAll('.breadcrumb-container');
        containers.forEach(c => {
            c.scrollLeft = c.scrollWidth;
        });
    });
})();
